// RightSection.jsx
import ProductCard from "./ProductCard";
import { useFilters } from "./FilterContext";
import { ThreeDot } from "react-loading-indicators";
function RightSection() {
  const { sortOption, handleSortChange,productData,observerRef,loading,hasMore,isSkeletonLoading,categoryName,categoryDescription,productCount,loader,selectedFilters,clearAllFilters } = useFilters();

  return (
    <>
    {isSkeletonLoading ? (
        // 👇 optional: show loader or skeleton while loading
        null
      ) : (
    <div className="right-section">
      {/* Header Section */}
      <div className="header-section">
        <div>
          <h2 className="category-title">{categoryName}</h2>
          <p className="category-description">
            {categoryDescription}
          </p>
          {productCount > 0 && 
            <span>Product Count:  {productCount} </span>
          }
           {selectedFilters.length > 0 && (
            <button onClick={e => {
                if (loader) {
                  e.preventDefault();
                }
                else{
                  clearAllFilters()
                }
              }} className="clear-all-btn mobile-clear" disabled={loader}>
                Clear All Filters
              </button>
          )}
        </div>
        <div className="sort-options">
          <label>Sort by:</label>
          <select value={sortOption} onChange={handleSortChange} disabled={loader} style={{ backgroundImage: `url("https://www.ourgreenhouse.com/content/Vector.svg")` }}>
            <option value="0">Default</option>
            <option value="3">Newest Items</option>
            <option value="4">Best Selling</option>
            <option value="1">Price: Ascending</option>
            <option value="2">Price: Descending</option>
          </select>
        </div>
      </div>

      {/* Product Grid */}
      <div className="product-grid">
        {productData.map((product, index) => (
          <ProductCard key={index} product={product} />
        ))}
      </div>

      {/* Loading indicator */}
      {loading && 
      <>
        <div className="page_load_more_loader">
          <ThreeDot
            variant="bob"
            color="#d8cfbb"
            size="medium"
            text=""
            textColor=""
          />
        </div>
      </>
      }

      {/* End message */}
      {!hasMore && <p style={{ textAlign: "center" }}>No more products to load</p>}

      {/* Sentinel element for IntersectionObserver */}
      <div ref={observerRef} style={{ height: "1px" }}></div>
    </div>
      )}
    </>
  );
}

export default RightSection;